import Http from '../http';

const page_prefix = '/page-config';
const layout_prefix = '/layout-config';
const website_prefix = '/website-config';


/**
 * traz todas as configs de uma pagina
 * @param {} layout_id
 */
export const getPageConfig = (page_id) => {
  return Http.authApi().get(`${page_prefix}/${page_id}`);
};

/**
 * cria ou atualiza config existente na pagina
 * @param { layout_id, key, value } params
 */

export const setPageConfig = (params) => {
  return Http.authApi().post(`${page_prefix}`, params);
};

/**
 * traz todas as configs de um layout
 * @param {} layout_id
 */
export const getLayoutConfig = (layout_id) => {
  return Http.authApi().get(`${layout_prefix}/${layout_id}`);
};

/**
 * cria ou atualiza config existente
 * @param { layout_id, key, value } params
 */

export const setLayoutConfig = (params) => {
  return Http.authApi().post(`${layout_prefix}`, params);
};


/**
 * traz todas as configs de um layout
 * @param {} layout_id
 */
export const getWebsiteConfig = (website_id) => {
  return Http.authApi().get(`${website_prefix}/${website_id}`);
};

/**
 * @param website_id
 * @param key
 */
export const getWebsiteConfigKey = (website_id, key) => {
  return Http.authApi().get(`${website_prefix}-key/${website_id}/${key}`);
};

/**
 * cria ou atualiza config existente
 * @param { layout_id, key, value } params
 */

export const setWebsiteConfig = (params) => {
  return Http.authApi().post(`${website_prefix}`, params);
};




// WEBPACK FOOTER //
// ./src/js/services/editor/configManager.js